import { Chatbot } from "@counselpro/counselkit";
import { useState } from "react";

import useAbortController from "@/services/lukita/hooks/use-abort-controller";
import { sendChatMessage } from "@/services/lukita/prompt-chat";
import { isProjectReportStatus } from "@/utils";

export default function DaystromAi({ project }) {
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState(project.promptHistory);
  const aborter = useAbortController();

  const handleStop = () => {
    aborter.abort();
    setIsLoading(false);
  };

  const appendMessage = (role, content) =>
    setMessages((prev) => [...prev, { role, content }]);

  const onResponse = async (content) => {
    setMessages((prev) => {
      const messages = [...prev];
      const lastMessage = messages[messages.length - 1];
      if (lastMessage.role === "ai") {
        lastMessage.content = content;
      } else {
        messages.push({ role: "ai", content });
      }

      return messages;
    });
  };

  const sendMessage = (message) =>
    sendChatMessage({
      slug: project.slug,
      message,
      onResponse,
      aborter,
    });

  const handleSendMessage = (value, onError) => {
    const message = value.trim();
    if (!message) return;

    setIsLoading(true);
    appendMessage("human", message);

    sendMessage(message)
      .catch(onError)
      .finally(() => setIsLoading(false));
  };

  const showChatbot = isProjectReportStatus(project, "generated");

  return (
    showChatbot && (
      <Chatbot
        handleSendMessage={handleSendMessage}
        messages={messages}
        isLoading={isLoading}
        onStop={handleStop}
      />
    )
  );
}
